import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledRoomLink = styled(Link)<{ isRetired?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  padding: 1.6rem 0;
  text-decoration: none;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
  border-bottom: 1px solid ${({ theme }) => theme.colors.background.darker};
  pointer-events: ${({ isRetired }) => (isRetired ? 'none' : 'auto')};
  cursor: ${({ isRetired }) => (isRetired ? 'default' : 'pointer')};

  &:hover {
    ${({ isRetired, theme }) =>
      !isRetired &&
      `
        font-weight: ${theme.fonts.weight.bold};
        background: ${theme.colors.background.dark};
    `}
  }

  img {
    width: 3.6rem;
    height: 3.6rem;
  }
`;
